export default __webpack_public_path__ + "static/media/Inkwell.9a3d461a.png";